import { IPlatform } from '@/types';
import Link from 'next/link';
import { Section } from '../section/section.comp';
import { StyledDiv } from './categoriesCatalog.styles';

export const CategoriesCatalog = ({
	platform,
	categories,
}: {
	platform: Partial<IPlatform>;
	categories: { displayName: string; slug: string }[];
}) => {
	if (!categories.length) {
		return <></>;
	}
	return (
		<Section>
			<StyledDiv>
				<p>Quick & Easy</p>
				<h2>
					Find the Best {platform.displayName} {platform.appSynonym}s for you
				</h2>
				<p className="desc">
					Common Ninja has a large selection of powerful {platform.displayName}{' '}
					{platform.appSynonym}s that are easy to use, fully customizable,
					mobile-friendly and rich with features — so be sure to check them out!
				</p>
				<div className="apps-container">
					{categories.length > 0 &&
						categories.map((cat) => {
							let path = `/${platform.name}/category/${cat.slug}`;
							return (
								<Link
									title={`${cat.displayName} ${platform.appSynonym}s for ${platform.displayName}`}
									key={cat.slug}
									className="app"
									href={path}
								>
									<div className="details">
										<h3>{cat.displayName}</h3>
										<p className="body-1">
											{cat.displayName} {platform.appSynonym}s for{' '}
											{platform.displayName}
										</p>
									</div>
								</Link>
							);
						})}
				</div>
			</StyledDiv>
		</Section>
	);
};
